// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {commitMutation, graphql} from 'react-relay'
import {ConnectionHandler, type Environment, type RecordSourceSelectorProxy} from 'relay-runtime'

import type {
  UpdateIssuesBulkInput,
  updateItemPickerIssueLabelsBulkMutation,
} from './__generated__/updateItemPickerIssueLabelsBulkMutation.graphql'

type issueUpdateArgs = {
  applyLabelIds: string[]
  removeLabelIds: string[]
}

export function updateIssuesById(
  store: RecordSourceSelectorProxy,
  ids: string[],
  existingIssueLabels: Map<string, string[]>,
  connectionIds: {[key: string]: string[]},
  issueUpdateArgs: issueUpdateArgs,
) {
  for (const id of ids) {
    const issue = store.get(id)
    if (!issue) return
    const connections = connectionIds[id]?.map(cId => store.get(cId))

    for (const labelId of issueUpdateArgs.applyLabelIds) {
      if (existingIssueLabels.get(id)?.includes(labelId)) return
      const label = store.get(labelId)
      if (!label) return
      connections
        ?.filter(connection => connection)
        .map(connection => {
          const edge = connection && ConnectionHandler.createEdge(store, connection, label, 'LabelEdge')
          if (edge) ConnectionHandler.insertEdgeBefore(connection, edge)
        })
    }

    for (const labelId of issueUpdateArgs.removeLabelIds) {
      connections
        ?.filter(connection => connection)
        .map(connection => connection && ConnectionHandler.deleteNode(connection, labelId))
    }
  }
}

export function commitUpdateItemPickerIssueLabelsBulkMutation({
  environment,
  optimisticUpdateIds,
  existingIssueLabels,
  connectionIds,
  input: {ids, applyLabelIds, removeLabelIds},
  onCompleted,
  onError,
}: {
  environment: Environment
  connectionIds: {[key: string]: string[]}
  input: {ids: string[]} & issueUpdateArgs
  optimisticUpdateIds: string[]
  existingIssueLabels: Map<string, string[]>
  onCompleted?: (response: updateItemPickerIssueLabelsBulkMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {applyLabelIds, removeLabelIds}
  const inputHash: UpdateIssuesBulkInput = {
    ids,
    ...inputArgs,
  }

  return commitMutation<updateItemPickerIssueLabelsBulkMutation>(environment, {
    mutation: graphql`
      mutation updateItemPickerIssueLabelsBulkMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    updater: store => updateIssuesById(store, optimisticUpdateIds, existingIssueLabels, connectionIds, inputArgs),
    optimisticUpdater: store =>
      updateIssuesById(store, optimisticUpdateIds, existingIssueLabels, connectionIds, inputArgs),
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
